jQuery(document).ready(function(){
    jQuery('.form-popup').delay(2000).fadeIn();

    jQuery(".js-close-form-popup").on("click", function (event) {
        jQuery('.form-popup').fadeOut();
        event.preventDefault();
    });    
    
});
jQuery('body').on('click', '.size-chart-holder-switch input', function() { jQuery(this).parents('.size-chart-holder').toggleClass('is-active-in'); });
jQuery('body').on('click', '.epr-title', function() { jQuery(this).parents('.not-in-quickbuy').toggleClass('is-active'); });


jQuery(window).scroll(function() {
    var height = jQuery(window).scrollTop();

    if(height  > 130) {
        jQuery('body').addClass('search-top-position');
    } else {
        jQuery('body').removeClass('search-top-position'); 
    }
});

